import { uniqBy } from 'lodash'

export function removeDuplicates<T>(
    labels: (T & { name: string; value: number })[]
): (T & { name: string; value: number })[] {
    labels = labels.map(item => {
        const duplicates = labels.filter(a => a.name === item.name)

        if (duplicates.length <= 1) return item

        return duplicates.filter(a => a.value !== undefined)[0] || item
    })

    return uniqBy(labels, x => x.name)
}
